var _rect, _circle, _path, _rect2, _rect3, _rect4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGlobalSelectIconBlue32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    fillOpacity: 0.01
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 15.5,
    r: 11.5,
    stroke: "#407EDB",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5 15.5C23.5 18.8767 22.6777 21.9096 21.3746 24.0816C20.0654 26.2635 18.3264 27.5 16.5 27.5C14.6736 27.5 12.9346 26.2635 11.6254 24.0816C10.3223 21.9096 9.5 18.8767 9.5 15.5C9.5 12.1233 10.3223 9.09041 11.6254 6.91841C12.9346 4.73647 14.6736 3.5 16.5 3.5C18.3264 3.5 20.0654 4.73647 21.3746 6.91841C22.6777 9.09041 23.5 12.1233 23.5 15.5Z",
    stroke: "#407EDB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 4,
    width: 1,
    height: 24,
    fill: "#407EDB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 11,
    width: 23,
    height: 1,
    fill: "#407EDB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 19,
    width: 23,
    height: 1,
    fill: "#407EDB"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobalSelectIconBlue32);
export default __webpack_public_path__ + "static/media/global_select_icon_blue_32.7dbf6255be250167c136b76a41241b50.svg";
export { ForwardRef as ReactComponent };